import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import BasicDatePicker from '../BasicDatePicker'
import MultipleDatePicker from '../MultipleDatePicker'
import calendarIcon from '../../images/svg/calendar 1.svg'
import { RequestsContext } from '../../context/requests'
import { FilterSallesContext } from "../../context/filterSalles";

const CardWrapper = styled.div`  
    position: relative;
`
const CardFilter = styled.div`
    padding-top: 1.2rem;
    transition: all 2s;
    position: absolute;
    z-index: 999999;
    width:320px;
    left: 15px;
    top: 40px;
    height: auto;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 0 5px #292727;

    p{
        font-family: "Poppins";
        font-weight: 500;
        font-size: 1.1rem;
        margin-left: 0.9rem;
    }

`
const Box = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;
`
const CardFilterOption = styled.button`
    font-family: "Poppins";
    font-weight: 500;
    font-size: 0.9rem;
    display: flex;
    justify-content: center;
    background-color: white;
    align-items: center;
    border: 1px solid black;
    border-radius: 15px;
    width:auto;
    height: 31px;
    margin-left: 0.9rem;

`
const Button = styled.button`
    
    font-family: "Poppins";
    font-weight: 500;
    font-size: 0.9rem;
    color: ${props => props.option != "sem filtro" ? "#0050dc" : ""};
    display: flex;
    justify-content: center;
    background-color: white;
    align-items: center;
    border: 1px solid black;
    border-radius: 15px;
    width:auto;
    height: 31px;
    margin-left: 0.9rem;

`
const ButtonClose = styled.button`
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-family: "Poppins";
    font-weight: 400;
    font-size: 0.9rem;
    display: flex;
    justify-content: center;
    background-color: white;
    align-items: center;
    border: 1px solid black;
    border-radius: 15px;
    width:auto;
    height: 31px;

`
const Image = styled.img`
    width: 15px;
    margin-right: 0.4rem;
`

const CardFilterDateTiny = () => {
    const {getLast30Days,getAll,setTypeFilter} = useContext(RequestsContext)
    const {option} = useContext(FilterSallesContext)
    const [active, setActive] = useState(false)
    const [UserSelectoption, setSelectOption] = useState("sem filtro")

    return (

        <CardWrapper>
            <Button option={UserSelectoption} onClick={() => setActive(true)}>
                <Image src={calendarIcon} />
                {UserSelectoption}
            </Button>

            {active && (
                <CardFilter>
                    <p>Período</p>
                    <Box>
                        <CardFilterOption onClick={() => { setTypeFilter("últimos 30 dias");getLast30Days(option,"últimos 30 dias");setSelectOption("últimos 30 dias");setActive(false) }}>últimos 30 dias</CardFilterOption>
                        <CardFilterOption onClick={() => { setTypeFilter(null);getAll(option);setSelectOption("sem filtro"); setActive(false) }}>sem filtro</CardFilterOption>
                    </Box>
                    <Box>
                        <CardFilterOption onClick={() => {setSelectOption("por data")}}>por data</CardFilterOption>
                        <CardFilterOption onClick={() => {setTypeFilter("por intervalo");setSelectOption("por intervalo")}}>do intervalo</CardFilterOption>
                    </Box>

                    {UserSelectoption == "por data" || UserSelectoption == "por mês"
                        ?
                        <BasicDatePicker />
                        :
                        UserSelectoption == "por intervalo" 
                        
                        ?
                        <MultipleDatePicker/>
                        :
                        <></>
                    }

                    <ButtonClose onClick={() => setActive(false)}>Fechar</ButtonClose>
                </CardFilter>
            )}
        </CardWrapper>

    )
}

export default CardFilterDateTiny